import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { ReportComponent } from './report/report.component';
import { HomeComponent } from './home/home.component';

import { LoginComponent } from './auth/containers/login/login.component';
import { AuthGuard } from './auth/guards/auth.guard';
import { ReportComponent } from './report/report.component';
import { ReportSummaryComponent } from './components/report-summary/report-summary.component';
import { ReportAllComponent } from './components/report-all/report-all.component';
const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/login' },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'report',
    component: ReportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'summary',
    component: ReportSummaryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'all',
    component: ReportAllComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
